import { NotificationCenter } from '@affine/component';
import { DefaultServerService } from '@affine/core/modules/cloud';
import { NotificationRealtimeBootstrap } from '@affine/core/modules/notification';
import { FrameworkScope, useService } from '@toeverything/infra';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { TermsAcceptanceGate } from '../../../components/auth/terms-acceptance-gate';
import { GlobalDialogs } from '../../dialogs';
import { CustomThemeModifier } from './custom-theme';
import { FindInPagePopup } from './find-in-page/find-in-page-popup';

export const RootWrapper = () => {
  const defaultServerService = useService(DefaultServerService);

  useEffect(() => {
    const abortController = new AbortController();
    void defaultServerService.server.waitForConfigRevalidation(
      abortController.signal
    );
    return () => {
      abortController.abort();
    };
  }, [defaultServerService]);

  return (
    <FrameworkScope scope={defaultServerService.server.scope}>
      <NotificationRealtimeBootstrap />
      <GlobalDialogs />
      <NotificationCenter />
      <TermsAcceptanceGate />
      <Outlet />
      <CustomThemeModifier />
      {BUILD_CONFIG.isElectron && <FindInPagePopup />}
    </FrameworkScope>
  );
};
